import React, { useState } from "react";

import { toast } from "react-hot-toast";
import { Input, Select } from "components/Form";
import { Button } from "components/Button/Button";
import useMuiButtonLoader from "hooks/useMuiButtonLoader";
import { getCenters, getCourseVertical } from "services/master";
import { addCenter } from "services/centers";
import ModalBox from "components/modal/ModalBox";
import { updateMasterState } from "services/citypages";

const UpdateMasterState = ({ open, onClose, selectedData, masterstatesListing }) => {
    const [submitButtonElement, setSubmitLoading] = useMuiButtonLoader();
    const [allCenters, setAllCenters] = useState([]);
    const [allVerticals, setAllVerticals] = useState([]);

    const [masterstateData, setCenterData] = useState({
        centerId: "",
        statename: "",
        statecode: "",
    });

    const [errorField, setErrorField] = useState({
        centerId: "",
        statename: "",
        statecode: "",
    });

    //*********************Handel Validation********************************** */
    const handleValidation = () => {
        let errorField = {};
        let formIsValid = true;

        if (!masterstateData.centerId) {
            errorField["centerId"] = "Please Select Centre";
            formIsValid = false;
        }
        if (!masterstateData.statename) {
            errorField["statename"] = "Please Enter State Name";
            formIsValid = false;
        }
        if (!masterstateData.statecode) {
            errorField["statecode"] = "Please Enter State Code";
            formIsValid = false;
        }

        setErrorField(errorField);
        return formIsValid;
    };

    //*********************Submit Center Handler********************************** */
    const submitCenterHandler = async (e) => {
        e.preventDefault();
        if (handleValidation()) {
            setSubmitLoading(true);
            try {
                const finalData = {
                    id: masterstateData.id,
                    statename: masterstateData.statename,
                    statecode: masterstateData.statecode,
                    centerid: masterstateData.centerId,
                };

                const res = await updateMasterState(finalData);

                if (res.code === 200) {
                    toast.success(res.message);
                    setSubmitLoading(false);
                    masterstatesListing();
                    modalOnClose();
                } else {
                    toast.error(res.message);
                    setSubmitLoading(false);
                }
            } catch (err) {
                toast.error(err?.response?.data?.message || err.message);
                setSubmitLoading(false);
            }

        } else {
            toast.error("Please fill all the fields");
        }
    };

    //   onChange Handler
    const onChangeHandler = (e) => {
        const { name, value } = e.target;
        if (name === "latitude" || name === "longitude") {
            setCenterData({ ...masterstateData, [name]: value.replace(/[^0-9.]/g, "") });
        } else {
            setCenterData({ ...masterstateData, [name]: value });
        }
    };

    // this function is used for clear data on close
    const modalOnClose = () => {
        setCenterData({
            centerId: "",
            verticalId: "",
            latitude: "",
            longitude: "",
        });
        onClose();
    };

    // --------------- getting all required masters data ----------------//
    React.useLayoutEffect(() => {
        const getCenterListing = async () => {
            try {
                const res = await getCenters();
                if (res.code === 200) {
                    setAllCenters(res.data.centers.rows || []);
                } else {
                    toast.error(res.message);
                }
            } catch (err) {
                toast.error(err?.response?.data?.message || err.message);
            }
        };

        const getVerticalData = async () => {
            try {
                const res = await getCourseVertical();
                if (res.code === 200) {
                    setAllVerticals(res.data.courseVerticles.rows || []);
                } else {
                    toast.error(res.message);
                }
            } catch (err) {
                toast.error(err?.response?.data?.message || err.message);
            }
        };

        // calls all the master functions
        getCenterListing();

        getVerticalData();

        // eslint-disable-next-line
    }, []);

    // --------------- set all selected data ----------------//
    React.useLayoutEffect(() => {
        if (open && selectedData?.id) {
            setCenterData({
                ...selectedData,
            });
        }

        // eslint-disable-next-line
    }, [selectedData]);

    return (
        <>
            <ModalBox
                status={open}
                onClose={modalOnClose}
                size="sm"
                title={"Update Master State"}
                customizedFooter={
                    <div>
                        <Button onClick={submitCenterHandler} {...submitButtonElement}>
                            Update Master State
                        </Button>
                    </div>
                }
            >
                <div className="form-group row mt-1">
                    <div className="col-sm-12 col-form-label order-1 d-flex flex-column justify-content-end">
                        <div className="row">

                            <div className="col-sm-6 col-form-label">
                                <Input
                                    type="text"
                                    name="statename"
                                    value={masterstateData.statename}
                                    onChange={onChangeHandler}
                                    placeholder="Enter State Name"
                                    className={`form-control `}
                                    label={"State Name"}
                                    error={errorField.statename}
                                    required
                                    {...submitButtonElement}
                                />
                            </div>
                            <div className="col-sm-6 col-form-label">
                                <Input
                                    type="text"
                                    name="statecode"
                                    value={masterstateData.statecode}
                                    onChange={onChangeHandler}
                                    placeholder="Enter State Code"
                                    className={`form-control `}
                                    label={"State Code"}
                                    error={errorField.statecode}
                                    required
                                    {...submitButtonElement}
                                />
                            </div>
                            <div className="col-sm-12 col-form-label">
                                <Select
                                    name="centerId"
                                    placeholder="Select Centre"
                                    onChange={onChangeHandler}
                                    value={masterstateData.centerId}
                                    className={`form-control `}
                                    label={"Default Center"}
                                    error={errorField.centerId}
                                    required
                                    {...submitButtonElement}
                                >
                                    <option value="">Select Centre</option>
                                    {allCenters &&
                                        allCenters.map(({ CenterID, CenterName }) => {
                                            return (
                                                <option value={CenterID} key={CenterID}>
                                                    {CenterName}
                                                </option>
                                            );
                                        })}
                                </Select>
                            </div>
                        </div>
                    </div>
                </div>
            </ModalBox>
        </>
    );
};

export default UpdateMasterState;
